module.exports = __webpack_public_path__ + "images/stickers/warning@2x.e0197b2fb0cbd4a389d4.png";